import type { KarrotLocalCountryCode } from "@karrotmarket-com/core";
import { enUS, ja, ko } from "date-fns/locale";

export function getDateFnsLocale({
  karrotLocalCountryCode,
}: {
  karrotLocalCountryCode: KarrotLocalCountryCode;
}) {
  switch (karrotLocalCountryCode) {
    case "ca":
    case "uk":
    case "us":
    default:
      return enUS;
    case "jp":
      return ja;
    case "kr":
      return ko;
  }
}
